import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("change", this.submit);
    this.element.form?.addEventListener("turbo:submit-end", this.stopLoading);
  }

  disconnect() {
    this.element.removeEventListener("change", this.submit);
    this.element.form?.removeEventListener("turbo:submit-end", this.stopLoading);
  }

  submit = () => {
    this.loadingElement?.classList.add("--loading");
    this.element.form.requestSubmit();
    this.element.value = "";
  };

  stopLoading = () => {
    this.loadingElement?.classList.remove("--loading");
  };

  get loadingElement() {
    return document.getElementById(this.element.dataset.orderFileLoadingId);
  }
}
